<template>
    <div ref="CheckingAccount">
      <div class="maf-section column-flex-layout">
          <div class="section-title">Change bank account</div>
          <div class="sub-title">Enter checking account details</div>
          <div class="question row-reverse-flex-layout">
              <div class="maf-right">
                  <div class="desc">
                      <div style="text-align: center;margin-bottom: 20px;">
                        <svg-icon :name="'check-account'" :width="304" :height="202"></svg-icon>
                      </div>
                      <span class="title">What do I need?</span>
                      <br>
                      <br>
                      <ul>
                          <li>You need a checking account that is under your name.</li>
                          <li>We can’t accept a pre-paid card or a savings account.</li>
                          <li>To make sure this program is secure and convenient for you, we use electronic transfers
                              to debit and credit your account.</li>
                          <li>Don’t worry - your bank account will not be used until you sign a loan agreement and
                              officially join one of our programs.</li>
                      </ul>
                  </div>
              </div>

              <div class="maf-left">
                  <div class="question">
                      <maf-input ref="bankName" name="Bank Name" :width="inputWidth" height="50" v-model="application.BankName__c" :required="true" :is-required-label="true" section-name="Checking Account"></maf-input>
                  </div>
                  <div class="question">
                      <maf-input name="Checking Account Number" :width="inputWidth" height="50" v-model="application.AccountNumber__c"
                          :required="true" :is-required-label="true" type="accountnumber" section-name="Checking Account" tip="Your account number is specific to your personal account. It’s usually 10-12 digits and is printed on the bottom of your checks, to the right of your bank routing number. You can also find your account number on your monthly bank statement."></maf-input>
                  </div>
                  <div class="question">
                      <maf-input ref="routingNumber" name="Routing Number" :width="inputWidth" height="50" v-model="application.RoutingNumber__c" :required="true" :is-required-label="true" type="routingnumber" section-name="Checking Account" tip="Your bank routing number is a 9-digit code that’s based on the location where you opened your account. It’s printed on the bottom of your checks, on the left side."></maf-input>
                  </div>
              </div>
          </div>
      </div>

      <div class="maf-section column-flex-layout">
        <div class="section-title">Provide proof of checking account</div>
        <div class="question row-reverse-flex-layout">
          <div class="maf-right">
            <div class="desc">
              <span class="title">Make sure that your bank verification has:</span>
              <br>
              <br>
              <ul>
                <li>Your full name</li>
                <li>Your bank’s name</li>
                <li>Your checking account number</li>
                <li>If uploading a letter from your bank, make sure it is on the bank’s letterhead and is typed (not handwritten)</li>
              </ul>
            </div>
          </div>
          <div class="maf-left">
            <div>
              <span :style="{ color: docLabelColor }">Document type</span>
              <span style="color: #FF0000">*Required</span>
            </div>
            <div style="position: relative;">
              <div class="flex-layout icon-flex-layout">
                <div class="question">
                  <maf-radio :options="voidedCheckOptions" v-model="application.Type_of_Bank_Document__c"></maf-radio>
                  <maf-radio :options="bankStatementOptions" v-model="application.Type_of_Bank_Document__c" tip="Bank statement that shows the checking account number and your name printed."></maf-radio>
                  <maf-radio :options="bankLetterOptions" v-model="application.Type_of_Bank_Document__c"></maf-radio>
                  <maf-radio :options="directDepositSlipOptions" v-model="application.Type_of_Bank_Document__c"></maf-radio>
                </div>
                <div class="type-svg" v-show="iconName">
                  <div :class="iconClass">
                    <svg-icon :name="iconName" :width="iconWidth" :height="iconHeight"></svg-icon>
                    <span style="position: absolute; top: 15px; left: 21px;" class="tip-icon tip-icon-right" v-show="application.Type_of_Bank_Document__c == 'Check'">
                      <p>Your full name</p>
                    </span>
                    <span style="position: absolute; top: 70px; left: 75px;" class="tip-icon tip-icon-left" v-show="application.Type_of_Bank_Document__c == 'Check'">
                      <p>Your account number</p>
                    </span>

                    <span style="position: absolute; top: 15%; left: 44%;" class="tip-icon tip-icon-right" v-show="application.Type_of_Bank_Document__c == 'Bank Statement'">
                      <p>Bank name</p>
                    </span>
                    <span style="position: absolute; top: 3%; left: 62%;" class="tip-icon tip-icon-left" v-show="application.Type_of_Bank_Document__c == 'Bank Statement'">
                      <p>Your full name</p>
                    </span>
                    <span style="position: absolute; top: 19%; left: 62%;" class="tip-icon tip-icon-left" v-show="application.Type_of_Bank_Document__c == 'Bank Statement'">
                      <p>Account number</p>
                    </span>

                    <span style="position: absolute;top: 3%;left: 58%;" class="tip-icon tip-icon-left" v-show="application.Type_of_Bank_Document__c == 'Letter from the Bank'">
                      <p>Bank name</p>
                    </span>
                    <span style="position: absolute;top: 12%;left: 46%;" class="tip-icon tip-icon-right" v-show="application.Type_of_Bank_Document__c == 'Letter from the Bank'">
                      <p>Your full name</p>
                    </span>
                    <span style="position: absolute;top: 36%;left: 42%;" class="tip-icon tip-icon-right" v-show="application.Type_of_Bank_Document__c == 'Letter from the Bank'">
                      <p>Account number</p>
                    </span>

                    <span style="position: absolute; top: 4%; left: 32%;" class="tip-icon tip-icon-right" v-show="application.Type_of_Bank_Document__c == 'Direct deposit slip from the bank'">
                      <p>Bank name</p>
                    </span>
                    <span style="position: absolute; top: 19%; left: 56%;" class="tip-icon tip-icon-left" v-show="application.Type_of_Bank_Document__c == 'Direct deposit slip from the bank'">
                      <p>Your full name</p>
                    </span>
                    <span style="position: absolute; top: 45%; left: 64%;" class="tip-icon tip-icon-left" v-show="application.Type_of_Bank_Document__c == 'Direct deposit slip from the bank'">
                      <p>Account number</p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="step2">
              <span class="a11y-upload-wrapper" tabindex="-1" data-a11y-first="true"
                @keydown.enter.space="$el.querySelector('input, button, label').click()"
                style="outline: none !important; display: inline-block; width: 100%; position: relative;">
                <maf-file-upload tabindex="0" style="outline: none;" session-id="text" :app-id="appId" name="Please upload a photo that clearly shows your proof of checking account."
                  :file-prefix="bankFilePrefix" :file-index="currentBankFileIndex" :has-type="application.Type_of_Bank_Document__c != ''"
                  :has-files="uploadedFiles.length > 0"></maf-file-upload>
              </span>
              <div class="uploaded-docs">
                <table class="uploaded-table">
                  <tbody>
                    <tr v-for="(file, index) in uploadedFiles" :key="index">
                      <td style="width:10%;">
                        <svg width="18px" height="13px" viewBox="0 0 18 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g transform="translate(-217.000000, -604.000000)" fill="url(#greenColor)" fill-rule="nonzero" stroke="url(#greenColor" stroke-width="1.014">
                              <g transform="translate(218.000000, 604.000000)">
                                <g>
                                  <g>
                                    <path d="M5.41828255,12 C5.15235457,12 4.90858726,11.9154659 4.70914127,11.7252642 L0.299168975,7.5196926 C-0.0997229917,7.13928915 -0.0997229917,6.54755043 0.299168975,6.16714697 C0.698060942,5.78674352 1.31855956,5.78674352 1.71745152,6.16714697 L5.44044321,9.69644573 L14.2825485,1.28530259 C14.6814404,0.904899135 15.3019391,0.904899135 15.700831,1.28530259 C16.099723,1.66570605 16.099723,2.25744476 15.700831,2.63784822 L6.14958449,11.7252642 C5.92797784,11.9154659 5.68421053,12 5.41828255,12 Z"></path>
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </td>
                      <td style="width:40%;padding-right: 10px;">
                        <span v-text="application.Type_of_Bank_Document__c"></span>
                      </td>
                      <td style="width:40%;padding-right: 10px;">
                        <span class="notranslate" v-text="getFileName(file.name)"></span>
                      </td>
                      <td style="width:10%;padding-right: 10px;">
                        <a href="javascript:void(0)" style="color: #D0021B;" @click="deleteFileFromFile(file)">Delete</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="horizontal-line"></div>
      <div class="question" style="display: flex;margin-bottom: 20px;">
        <label style="margin-right: 10px;">
          <input type="checkbox" id="certify" v-model="isAgree" class="maf-s-checkbox" />
          <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g stroke="url(#greenColor)">
                      <g>
                          <rect x="0.5" y="0.5" width="19" height="19" rx="3"></rect>
                      </g>
                      <path d="M8.40235457,15 C8.18628809,15 7.98822715,14.9308357 7.82617729,14.7752161 L4.24307479,11.3342939 C3.91897507,11.0230548 3.91897507,10.5389049 4.24307479,10.2276657 C4.56717452,9.91642651 5.07132964,9.91642651 5.39542936,10.2276657 L8.42036011,13.1152738 L15.6045706,6.23342939 C15.9286704,5.9221902 16.4328255,5.9221902 16.7569252,6.23342939 C17.0810249,6.54466859 17.0810249,7.02881844 16.7569252,7.34005764 L8.9965374,14.7752161 C8.81648199,14.9308357 8.61842105,15 8.40235457,15 Z"
                          stroke-width="0.845" fill="url(#greenColor)" fill-rule="nonzero"></path>
                  </g>
              </g>
          </svg>
        </label>
        <div :class="{'maf-font-weight': isAgree}" style="font-size:16px;color: #44546a;">
          I hereby authorize payments and disbursements to utilize this bank account. I understand that it will take
          <strong style="color: #3b434b;"> 5-7 business days</strong>
            for this change to go into effect, if no follow-up is required.
          <span style="color: #FF0000">*Required</span>
        </div>
      </div>

      <div class="button-container">
        <maf-button class="button" :name="'Exit'" :width="btnWidth" :fontSize="btnFont" :bgColor="'-webkit-linear-gradient(left top, #3023AE, #C86DD7)'" @actionFunc="cancelSubmit()"/>
        <maf-button class="button" :name="'Submit'" :width="btnWidth" :fontSize="btnFont" :disabled="isValid" @actionFunc="confirmSubmit()"/>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { deleteFileFromFile, checkAccountSubmit } from '../../api';

export default {
  props: {
    appId: String,
    loanIndex: Number,
    value: Boolean,
    loanId: String
  },
  data() {
    return {
      application: {
        attributes: { type: 'ClientApplication__c' },
        BankName__c: '',
        RoutingNumber__c: '',
        AccountNumber__c: '',
        Type_of_Bank_Document__c: ''
      },
      voidedCheckOptions: [
        {label: 'Voided Check', value: 'Check'}
      ],
      bankStatementOptions: [
        {label: 'Bank Statement', value: 'Bank Statement'}
      ],
      bankLetterOptions: [
        {label: 'Letter from your bank', value: 'Letter from the Bank'}
      ],
      directDepositSlipOptions: [
        {label: 'Direct deposit slip from the bank', value: 'Direct deposit slip from the bank'}
      ],
      uploadedFiles: [],
      currentBankFileIndex: 1,
      alerting: false,
      msg: '',
      content: '',
      showCancelSubmit: false,
      showConfirmSubmit: false,
      isShowErrorPopup: false,
      inputWidth: 264,
      isAgree: false
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.isLoading,
      userInfo: state => state.userInfo,
      isMobile: state => state.isMobile,
    }),
    btnWidth() {
      return 200;
    },
    btnFont() {
      if (this.isMobile) {
        return 14;
      }
      return 16;
    },
    docLabelColor() {
      return this.application.Type_of_Bank_Document__c !== '' ? '#393C40' : '#878787';
    },
    isValid() {
      if (this.application.BankName__c && this.application.AccountNumber__c && this.application.RoutingNumber__c && this.application.RoutingNumber__c.length === 9 && this.application.Type_of_Bank_Document__c && this.uploadedFiles.length > 0 && this.isAgree) {
        return false;
      }
      return true;
    },
    iconName() {
      if (this.application.Type_of_Bank_Document__c === 'Check') {
        return 'voided-check';
      } else if (this.application.Type_of_Bank_Document__c === 'Bank Statement') {
        return 'bank-statement';
      } else if (this.application.Type_of_Bank_Document__c === 'Letter from the Bank') {
        return 'letter-from';
      } else if (this.application.Type_of_Bank_Document__c === 'Direct deposit slip from the bank') {
        return 'direct-deposit';
      }
      return '';
    },
    iconClass() {
      if (this.application.Type_of_Bank_Document__c) {
        if (this.application.Type_of_Bank_Document__c === 'Check') {
          return 'checkSvg';
        } else {
          return 'otherBankSvg';
        }
      }
      return ''
    },
    iconWidth() {
      if (this.application.Type_of_Bank_Document__c === 'Check') {
        return 250;
      } else {
        return 203;
      }
    },
    iconHeight() {
      if (this.application.Type_of_Bank_Document__c === 'Check') {
        return 116;
      } else {
        return 242;
      }
    },
    bankFilePrefix() {
      return `${this.application.Type_of_Bank_Document__c}_${this.userInfo.firstName} ${this.userInfo.lastName}`;
    }
  },
  watch: {
    alerting(newValue) {
      let popup = {
        msg: this.msg,
        content: this.content,
        showCancelSubmit: this.showCancelSubmit,
        showConfirmSubmit: this.showConfirmSubmit,
        isShowErrorPopup: this.isShowErrorPopup,
        alerting: newValue
      };
      this.$emit('updateIsManualValid', popup);
    }
  },
  methods: {
    cancelSubmit() {
      this.alerting = true;
      this.showCancelSubmit = true;
      this.msg = 'Are you sure you want to exit?';
      this.content = '<span>Information or files entered in the previous step may not be saved.<br><br>The bank account currently connected will continue to be used for payments and disbursements related to your loan with MAF.</span>';
    },
    confirmSubmit() {
      this.alerting = true;
      this.showConfirmSubmit = true;
      this.msg = 'Your bank account information is being reviewed';
      this.content = '<span>If the information provided is sufficient, bank account changes will go into effect in 5-7 business days. <br><br>If we cannot verify your account, we will reach out via email and request that you submit this form again. <br><br>If your next payment is scheduled sooner than 5-7 business days and your current account does not have sufficient funds or is not available for use, please contact us at <a class="notranslate" href="mailto:programs@missionassetfund.org">programs@missionassetfund.org</a>.</span>';
    },
    confirmCancel() {
      this.clearPopup();
    },
    submit() {
      this.clearPopup();
      const params = {
        appId: this.appId,
        loanId: this.loanId,
        accountNumber: this.application.AccountNumber__c,
        rountingNumber: this.application.RoutingNumber__c,
        institutionName: this.application.BankName__c,
        fileIds: this.uploadedFiles.map(field => field.id),
        typeOfBank: this.application.Type_of_Bank_Document__c,
        chaseAccountNumberMask: ''
      }
      this.$store.state.isLoading = true;
      this.submitWithManual(params);
    },
    async submitWithManual(params) {
      const res = await checkAccountSubmit(JSON.stringify(params), this.userInfo.userId);
      this.$store.state.isLoading = false;
      if (res === 'SUCCESS') {
        this.updateButtonStatus('Manual');
      } else {
        self.content = res
      }
      if (self.content) {
        self.msg = 'Change bank account request failed. Please contact MAF Support!'
        self.alerting = true
        self.isShowErrorPopup = true;
        return false;
      }

      return true;
    },
    updateButtonStatus(method) {
      this.$store.state.dashboardHomeData.program.activeProgram.viewLoans[this.loanIndex].isUpdateButtonPending = true;
      this.$store.state.dashboardHomeData.program.activeProgram.viewLoans[this.loanIndex].verificationMethod = method;
    },
    clearPopup() {
      this.alerting = false;
      this.msg = '';
      this.content = '';
      this.showCancelSubmit = false;
      this.showConfirmSubmit = false;
      this.isShowErrorPopup = false;
    },
    adjustInputWidth() {
      let w = document.documentElement.clientWidth - 40
      if (w > 728) {
        this.inputWidth = 264
      } else {
        this.inputWidth = w
      }
    },
    hasFiles(prefix) {
      for (var file of this.uploadedFiles) {
        if (file.name.startsWith(prefix)) {
          return true;
        }
      }
      return false;
    },
    async deleteFileFromFile(file) {
      if (file.isDeleted) {
        return;
      }
      file.isDeleted = true;
      let self = this;
      const res = await deleteFileFromFile(file.id);
      const uploadedWrapper = JSON.parse(res.replaceAll('&quot;', '"'));
      if (uploadedWrapper.code === 'SUCCESS') {
        self.uploadedFiles.splice(self.uploadedFiles.indexOf(file), 1)
      } else {
        self.msg = 'failed to delete'
      }
      if (self.msg) {
        self.alerting = true
      }
    },
    handleResult(fileId, fileName) {
      this.uploadedFiles.push({
        id: fileId,
        name: fileName,
        isDeleted: false,
      })
    },
    getFileName(fileName) {
      return this.application.Type_of_Bank_Document__c + fileName.substring(fileName.indexOf('_'));
    }
  },
  mounted() {
    if (window.Plaid) {
      this.plaid = window.Plaid
      return
    }

    let linkScript = document.createElement('script')
    linkScript.async = true
    linkScript.setAttribute('src', 'https://cdn.plaid.com/link/v2/stable/link-initialize.js')
    document.head.appendChild(linkScript)

    linkScript.onload = () => {
      this.plaid = window.Plaid
    }
    this.adjustInputWidth();
  }
}
</script>

<style scoped lang="scss">
@import './../../sass/main.scss';

.maf-section .flex-layout {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.section-title {
  font-family: San Francisco Weight;
  font-size: 28px;
  color: #834bc4;
  letter-spacing: 0.32px;
  margin: 10px 0px;
  line-height: 1;
}

.sub-title {
  font-size: 18px;
  color: #878787;
  letter-spacing: 0.21px;
  margin-top: 12px;
}

.maf-section .question {
  padding: 20px 0;
}

.row-reverse-flex-layout {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
}

.maf-left {
  max-width: 390px;
}

.maf-right .desc {
  padding-left: 48px;
  border-left: 1px solid #ccc;
  width: 375px;
  font-size: 16px;
  color: #393c40;
}

.maf-right .desc .title {
  font-size: 18px;
  color: #878787;
  font-family: San Francisco Weight;
  letter-spacing: 0.21px;
}

.maf-right .desc ul {
  padding-left: 25px;
  margin-bottom: 40px;
}

.maf-right .desc ul li ~ li {
  margin-top: 16px;
}

.title {
  text-transform: unset;
}

.maf-alert {
  display: none;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  width: 300px;
  padding: 30px;
  background: #fefefe;
  box-shadow: 0 2px 10px 0 rgba(138, 138, 138, 0.5);
  border-radius: 7px;
  text-align: center;
  margin-top: 50px;
}

.maf-alert.open {
  display: block;
  min-width: 420px;
}

.maf-alert.maf-actions{
  display: block;
}

.maf-alert .title {
  font-family: San Francisco Weight;
  font-size: 20px;
  color: #834bc4;
  letter-spacing: 0.21px;
  text-align: center;
}

.maf-alert .content {
  margin: 20px 0;
  font-size: 16px;
  color: #393c40;
  letter-spacing: 0;
  text-align: center;
  line-height: 23px;
}

.maf-alert .maf-button.purple ~ .maf-button {
  margin-left: 50px;
}

.maf-alert .maf-button.purple ~ .maf-button {
  margin-left: 50px;
}

.type-svg {
  width:477px;
  max-height:242px;
  padding-top: 20px;
}

.checkSvg {
  position: relative;
  max-height: 116px;
  max-width: 250px;
  left: 50px;
}

.otherBankSvg {
  position: relative;
  max-height: 242px;
  max-width: 477px;
  left: 70px;
}

.otherBankSvg .tip-icon {
  margin-left: -140px;
}

.uploaded-docs {
  width: 390px;
}

.uploaded-table {
  width: 390px;
}

.button-container {
  display: flex;
  gap: 20px;
  justify-content: flex-end;
}

.maf-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.51;
  background: #44546a;
  display: none;
}

.maf-mask.open {
  display: block;
}

.checkbox-container {
  display: flex;
  align-items: center;
}

.custom-checkbox {
  margin-right: 10px;
}

.text {
  text-align: center;
}

.horizontal-line {
  max-width: 390px;
  border-top: 1px solid #ccc;
  margin: 20px 0;
}

.icon-flex-layout {
  flex-direction: column-reverse !important;
}

.tip-icon {
  position: relative;
  display: inline-block;
  text-align: center;
  background-color: #834bc4;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 15px;
  line-height: 22px;
  margin-left: 20px;
  cursor: pointer;
  font-family: San Francisco !important;
}

.tip-icon:before {
  content: '?';
  color: #fff;
}

.tip-icon:hover p {
  display: block;
  transform-origin: 100% 0%;
  -webkit-animation: fadeIn 0.3s ease-in-out;
  animation: fadeIn 0.3s ease-in-out;
}

.tip-icon p {
  display: none;
  text-align: left;
  background-color: #6b40be;
  padding: 16px;
  width: 200px;
  position: absolute;
  border-radius: 5px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  bottom: 32px;
  color: #fff;
  font-size: 0.9rem;
  line-height: 1.4;
  z-index: 1000;
  cursor: default;
  right: -192px;
}

.tip-icon p:before {
  position: absolute;
  content: '';
  width: 0;
  height: 0;
  border: 12px solid transparent;
  border-top-color: #6446b7;
  left: -12px;
  bottom: -8px;
  transform: rotate(135deg);
}

@media screen and (max-width: 768px), screen and (max-width: 950px) and (max-height: 500px) {
  .column-flex-layout .flex-layout {
      flex-direction: column;
      max-width: unset;
  }

  .maf-left {
    width: unset;
  }

  .row-reverse-flex-layout {
    display: flex;
    flex-direction: column;
  }

  .maf-right .desc {
    padding-left: 20px;
    width: 350px;
    border-left: unset;
  }

  .maf-alert {
    padding: 20px;
    width: calc(100% - 80px);
  }

  .maf-alert.open {
    min-width: unset;
  }

  .maf-alert .maf-button {
    width: 80%;
  }

  .maf-alert .maf-button.purple ~ .maf-button {
    margin-top: 10px;
    margin-left: 0;
  }

  .maf-alert .maf-button {
    width: 80%;
  }

  .maf-alert .maf-button.purple ~ .maf-button {
    margin-top: 10px;
    margin-left: 0;
  }

  .button-container {
    flex-direction: column-reverse;
  }

  .uploaded-docs {
    width: 100%;
  }

  .uploaded-table {
    width: 100%;
  }

  .type-svg {
    width: unset;
  }

  .checkSvg {
    left: unset;
    margin: auto;
  }

  .otherBankSvg {
    margin: auto;
    left: unset;
    text-align: center;
  }

  .tip-icon p {
    right: 10px;
    width: calc(100vw - 250px);
  }

  .tip-icon p:before {
    left: auto;
    right: 0px;
    bottom: -8px;
    transform: rotate(90deg);
  }

  .reduced-tip {
    right: 20px;
  }

  .otherBankSvg .tip-icon {
    margin-left: 0px;
  }

  .tip-icon-right p {
    left: 10px;
  }

  .tip-icon-right p:before {
    left: -12px;
    bottom: -8px;
    transform: rotate(135deg);
  }

  .tip-icon-right p {
    width: 160px;
    left: 10px;
  }

  .tip-icon-right p:before {
    left: -12px;
    bottom: -8px;
    transform: rotate(135deg);
  }

  .tip-icon-left p {
    width: 160px;
    right: 10px;
  }

  .tip-icon-left p:before {
    left: auto;
    right: 0px;
    bottom: -8px;
    transform: rotate(90deg);
  }

  .maf-btn {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/CheckingAccount.vue